import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ImportWspManager } from '../service/import-wsp.manager';
import { WspProjectExportService } from '../service/wsp-project-export.service';
import { UserPermissionService } from '@user/service/user-permission.service';

export enum ActionType {
  export,
  import,
}

@Component({
  standalone: false,
  templateUrl: './choice-action-local-backup.component.html',
  selector: 'app-choice-action-local-backup',
})
export class ChoiceActionLocalBackupComponent implements OnInit {
  public readonly types: ActionType[] = [ActionType.import, ActionType.export];

  public actionType: ActionType = ActionType.import;

  public importDisabled = false;
  public exportDisabled = false;

  constructor(
    private bsModalRef: BsModalRef,
    private importWspManager: ImportWspManager,
    private wspProjectExportService: WspProjectExportService,
    private userPermissionService: UserPermissionService,
  ) {}

  ngOnInit(): void {
    if (!this.userPermissionService.isLocalBackupVisibleImport()) {
      this.importDisabled = true;
      this.actionType = this.types[1];
    }
    if (!this.userPermissionService.isLocalBackupVisibleExport() || !this.userPermissionService.isLocalBackupEnabledExport()) {
      this.exportDisabled = true;
      this.actionType = this.types[0];
    }
  }

  public async onConfirm(): Promise<void> {
    switch (this.actionType) {
      case ActionType.export:
        this.exportWSP();
        this.close();
        break;
      case ActionType.import:
        await this.importWSP();
        this.close();
        break;
    }
  }

  public close(): void {
    this.bsModalRef.hide();
  }

  public async importWSP(): Promise<void> {
    await this.importWspManager.importWspProject();
  }

  public exportWSP(): Promise<void> {
    return this.wspProjectExportService.exportProject();
  }
}
